import { TONES } from './constants'
import { ToneKey } from './models'

export const startOfWeek = (d: Date): Date => {
  const nd = new Date(d)
  const day = nd.getDay()
  const diff = (day === 0 ? -6 : 1) - day
  nd.setDate(nd.getDate() + diff)
  nd.setHours(0, 0, 0, 0)
  return nd
}

export const isoWeek = (d: Date): number => {
  const t = new Date(d)
  t.setHours(0, 0, 0, 0)
  t.setDate(t.getDate() + 3 - ((t.getDay() + 6) % 7))
  const w1 = new Date(t.getFullYear(), 0, 4)
  return 1 + Math.round(((t.getTime() - w1.getTime()) / 86400000 - 3 + ((w1.getDay() + 6) % 7)) / 7)
}

export const fmtDay = (d: Date): string =>
  d.toLocaleDateString('es-CL', { day: 'numeric', month: 'short' })

export const toneStyles = (tone: ToneKey): { background: string, color: string } => ({
  background: TONES[tone].bg,
  color: TONES[tone].ink
})

// Estado de stock de un insumo respecto a su safety stock:
// óptimo (verde) ≥ 90%, bajo (ámbar) ≥ 40%, crítico (rosa) < 40%.
export const stockTone = (value: number, objetivo: number): ToneKey => {
  const pct = objetivo > 0 ? (value / objetivo) * 100 : 100
  if (pct >= 90) return 'green'
  if (pct >= 40) return 'amber'
  return 'rosa'
}

// Tono según días sin retiro / días en estado (para semáforos de atraso).
export const diasTone = (dias: number): ToneKey => {
  if (dias <= 5) return 'green'
  if (dias <= 10) return 'amber'
  return 'rosa'
}
